import { render, staticRenderFns } from "./pc-specs.vue?vue&type=template&id=98a04656&scoped=true&"
import script from "./pc-specs.vue?vue&type=script&lang=js&"
export * from "./pc-specs.vue?vue&type=script&lang=js&"
import style0 from "./pc-specs.vue?vue&type=style&index=0&id=98a04656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a04656",
  null
  
)

export default component.exports